import React from "react"
import PropTypes from "prop-types"

import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"

const options = { appearance: { theme: "flat" } }
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

StripeWrapper.propTypes = {
  children: PropTypes.node.isRequired
}

export default function StripeWrapper({ children }) {
  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  )
}
